module.exports = __webpack_public_path__ + "img/arrow.c9073bac.svg";